export default __webpack_public_path__ + "images/dd2725c432a64330c69ae837f5edf7c0-lacross.webp";